import { Component, OnInit, Inject, Input, ViewChild, ElementRef, ViewChildren, QueryList } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { VenueModelResponse } from 'src/app/_models/Venue/VenueModel';
import { ApiService } from 'src/app/_services/api.service';
import { Operations } from 'src/app/_models/Operations/Operations';
import { GetHostsModelResponse } from 'src/app/_models/Host/HostModel';
import { HostDialogComponent } from '../host-dialog/host-dialog.component';
import { MultiSelectVenueComponent } from '../../multi-select-venue/multi-select-venue.component';

@Component({
  selector: 'app-view-host-dialog',
  templateUrl: './view-host-dialog.component.html',
  styleUrls: ['./view-host-dialog.component.scss']
})
export class ViewHostDialogComponent implements OnInit {

  loading: boolean = false;
  operationType: Operations;

  hostId: string = '';
  venueIDs: string[]=[];
  venueNames: string[]=[];
  companyID: string = '';
  host: GetHostsModelResponse = {};

  constructor(
    private dialogRef: MatDialogRef<ViewHostDialogComponent>,
    private apiService: ApiService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.operationType = data.operation;
    this.hostId = data.hostId;
    this.host = data.host;
    this.companyID = data.companyId;
  }

  ngOnInit(): void {
  }

  close() {
    this.dialogRef.close(true);
  }


  openEditVenue(hostID: string | undefined) {
    this.close();
    const dialogConfig = new MatDialogConfig();

    dialogConfig.panelClass = 'custom-modal';

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      operation: Operations.Edit,
      hostId: hostID,
      host: this.host,
      companyId: this.companyID
    };

    const dialogRef = this.dialog.open(HostDialogComponent, dialogConfig)

    dialogRef.afterClosed().subscribe(closed => {
      if(!closed) {
        this.apiService.getHostsByCompany(this.companyID).subscribe();
      }
    });
  }

  deactivateHost(hostID: string | undefined) {
    this.close();
    const dialogConfig = new MatDialogConfig();

    dialogConfig.panelClass = 'custom-modal';

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      operation: Operations.Delete,
      venueId: hostID,
    };

    const dialogRef = this.dialog.open(HostDialogComponent, dialogConfig)

    dialogRef.afterClosed().subscribe(closed => {
      if(!closed && hostID) {
        this.apiService.deactiveHost(hostID).subscribe(() => {
          this.apiService.getHostsByCompany(this.companyID).subscribe();
        })
      }
    });
  }
}
